import Loader from "react-loader-spinner";
import momentJalaali from "moment-jalali";
import DatePicker from "react-datepicker2";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { EyeFill, EyeSlashFill, FileEarmarkExcelFill, FileEarmarkTextFill, PrinterFill, Search } from "react-bootstrap-icons";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { faBroom, faFileInvoice } from "@fortawesome/free-solid-svg-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getInvoiceDetailsReport } from "../store/api/ReportsAPI";
import { exportToExcel } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";

const InvoiceDetailsReport = () => {
    const { register, handleSubmit } = useForm();
    const history = useHistory();
    const frmFilters = useRef();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const [showFilter, setShowFilter] = useState(true);
    const { filterData } = useSelector(state => { return { filterData: state.ReportReducer.invoiceDetailsFilters } });
    const [dateFilters, setDateFilters] = useState({
        ContactDateFrom: filterData?.ContactDateFrom,
        ContactDateTo: filterData?.ContactDateTo
    })
    const tableCols = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
        { colTitle: "شماره فاکتور", colName: "InvoiceNumber", justInMobile: true },
        { colTitle: "تاریخ فاکتور", colName: "PContactDate", justInMobile: true },
        { colTitle: "طرف حساب", colName: "CustomerName", justInMobile: true },
        { colTitle: "کد کالا", colName: "ProductCode" },
        { colTitle: "مشخصات کالا", colName: "ProductName+ProductModel", colType: "string" },
        { colTitle: "تعداد", colName: "ProductCount" },
        { colTitle: "قیمت واحد", colName: "UnitPrice", colType: "currency" },
        { colTitle: "جمع", colName: "TotalPrice", colType: "currency" },
        { colTitle: "تخفیف", colName: "Discount", colType: "currency" },
        { colTitle: "مالیات", colName: "Tax", colType: "currency" },
        { colTitle: "قابل پرداخت", colName: "PureTotalPrice", colType: "currency" }
    ]
    const rowButtons = [
        { type: "common", title: "نمایش فاکتور", className:"group-Btn-smalll", icon: <FileEarmarkTextFill color="#1b9964" size={18} className="rowBtn" />, 
        tooltip: "نمایش فاکتور(برای نمایش در تب جدید کلید Ctrl را نگه دارید)", onclick: showInvoice }
    ]
    function showInvoice(row) {
        if (row.e.ctrlKey) {
            window.open(`/Sale/Invoice/${filterData.InvoiceType}/${row.InvoiceID}/${row.IsFormal}`);
        }
        else {
            history.push(`/Sale/Invoice/${filterData.InvoiceType}/${row.InvoiceID}/${row.IsFormal}`);
        }
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        const contactDateFrom = document.getElementsByName("ContactDateFrom")[0].value;
        const contactDateTo = document.getElementsByName("ContactDateTo")[0].value;
        if (contactDateFrom !== '') {
            data.ContactDateFrom = dateFilters.ContactDateFrom;
            data.PContactDateFrom = contactDateFrom;
        }
        if (contactDateTo !== '') {
            data.ContactDateTo = dateFilters.ContactDateTo;
            data.PContactDateTo = contactDateTo;
        }
        data.Skip = 0;
        dispatch(getInvoiceDetailsReport(data))
    }
    function clearFilters() {
        frmFilters.current.reset();
        setDateFilters({
            ContactDateFrom: null,
            ContactDateTo: null
        })
        dispatch(getInvoiceDetailsReport({ Skip: 0, Take: 10, InvoiceType: "Sale" }));
    }
    function toExcel() {
        const url = "api/InvoiceAPI/GetInvoiceDetailsReport";
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = 0;
        setPending(true);
        exportToExcel("InvoiceDetailsReport", searchArgs, url, "post", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { ...filterData };
        searchArgs.Skip = 0;
        searchArgs.Take = -1;
        history.push({
            pathname: `/PrintViewer/InvoiceDetailsReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/InvoiceAPI/GetInvoiceDetailsReport`,
                method: "post",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    useEffect(() => {
        document.body.className = "notMain";
    }, [])
    return (
        <div className="container-fluid mt-4">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faFileInvoice} size="lg" />&nbsp;
                    گزارش ریز خرید و فروش
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <form readOnly onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row id="divFilters" className="rowBorder" >
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>

                            <Col md={2} className="form-group">
                                <label>نوع فاکتور: </label>
                                <select className="form-control" name="InvoiceType" ref={register({})} defaultValue={filterData?.InvoiceType ?? "Sale"}>
                                    <option value="Sale">فاکتور های فروش</option>
                                    <option value="Purchase">فاکتورهای خرید</option>
                                </select>
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام/نوع کالا: </label>
                                <Form.Control name="ProductName" ref={register({})} defaultValue={filterData?.ProductName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>مدل کالا: </label>
                                <Form.Control name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام طرف حساب: </label>
                                <Form.Control name="CustomerName" ref={register({})} defaultValue={filterData?.CustomerName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ فاکتور از: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateFrom"
                                    value={dateFilters.ContactDateFrom ? momentJalaali(dateFilters.ContactDateFrom) : null}
                                    onChange={value => setDateFilters({ ...dateFilters, ContactDateFrom: value.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>تاریخ فاکتور تا: </label>
                                <DatePicker isGregorian={false} timePicker={false} className="form-control" name="ContactDateTo"
                                    value={dateFilters.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null}
                                    onChange={val => setDateFilters({ ...dateFilters, ContactDateTo: val.local("en").format("YYYY-MM-DD") })} />
                            </Col>
                        </Row>
                        <Button type="submit" className="group-Btn-large mt-1"><Search size={17} />&nbsp;جستجو&nbsp;</Button>
                    </form>
                    {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={rowButtons} filterData={filterData} reducerName="ReportReducer" objectName="invoiceDetailsReport"
                        searchMethod={(data) => dispatch(getInvoiceDetailsReport(data))} hasPaging style={{ whiteSpace: "nowrap" }} className="mt-0" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default InvoiceDetailsReport;